<template>
  <div id="prize">
  <div class="userInfo">{{town}},{{village}}的{{username}}您好，您的中奖情况如下:</div>
    <p v-if="prizeList.length==0">暂无奖品</p>
    <p v-for="prize in prizeList" :key="prize.id">{{prize.prizeName}}      x 1</p>
    
    <div class="shuoming">
      <p>
        <b>领取时间：</b>2月13日—2月24日（上午9:00-11:30，下午2:00-4:30，周末除外）<br>
<b>领取地点：</b>中了钥匙扣、帆布袋，请前往本人所在辖区派出所领取，其他奖品请至横湖中路161号（温岭市融媒体中心一楼大厅门卫处）领取。
      </p>
    </div>
  </div>
</template>

<script>
import { myPrizeList } from '@/api/fanzha'
export default {
data() {
  return {
      prizeList:[],
      username:"",
      town:"",
      village:"",
      themeId: 2
  }
},
mounted() {
  //获取我的奖品
  myPrizeList({themeId: this.themeId}).then((res)=>{
    if(res.code == 1) {
      this.prizeList = res.data.myPrizeList;
      this.username = res.data.fanzhaUserInfo.username;
      this.town = res.data.fanzhaUserInfo.town;
      this.village = res.data.fanzhaUserInfo.village;
    }
  })
}
}
</script>

<style lang="less" scoped>
.userInfo {
  margin-bottom: 40px;
  font-size: 12px;
}
.shuoming {
  margin-top: 65px;
  background-color: yellow;
  p {
   color: black; 
  }
}

</style>